import React, { useState } from 'react';
import { Row, Col, Card, CardBody, CardHeader, Label, Input, FormGroup, Collapse } from 'reactstrap';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import Select, { components, ValueContainerProps } from 'react-select';
import './Lmu.css';

const Option = (props) => {
    return (
        <div>
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                />{" "}
                <label>{props.label}</label>
            </components.Option>
        </div>
    );
};


const EnterpriseDetailForm = ({ form, handleFormFieldChange, handleMultiSelectChange, enterpriseIsOpen, enterpriseIsIconUp, enterpriseToggle }) => {
    //const [isOpen, setIsOpen] = useState(false);
    //const [isIconUp, setIsIconUp] = useState(false);

    //const enterpriseToggle = () => {
    //    setIsOpen(!isOpen)
    //    setIsIconUp(!isIconUp)
    //};

    return (
        <Card className="my-3">
            <CardHeader className="card-header-click" onClick={enterpriseToggle}>
                <Row>
                    <Col sm="11">
                        <h6>Enterprises / Farming Activities&nbsp;<span style={{ color: "red",fontSize:"13px" }}>(select at least 1 farming activity, or tick above if none)</span></h6>
                    </Col>
                    <Col sm="1" className="toggleoutline_lt">{enterpriseIsIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                </Row>
            </CardHeader>
            <Collapse isOpen={enterpriseIsOpen}>
                <CardBody>
                    <Row>
                        <Col sm="12">
                            <FormGroup id="diventerpriseType">
                                <Label for="enterpriseType">Select Enterprises / Farming Activities done on this LU</Label>
                                <Select
                                    id="enterpriseType"
                                    name="enterpriseType"
                                    closeMenuOnSelect={false}
                                    className="dropdown lmuEnterpriseType"
                                    placeholder="Select Enterprise Type"
                                    defaultValue={form.enterpriseType}
                                    options={form.enterpriseTypeList}
                                    onChange={handleMultiSelectChange}
                                    isClearable={false} isMulti hideSelectedOptions={false}
                                    components={{
                                        Option
                                    }}
                                />
                                <input type="hidden" id="hdnenterpriseType"></input>
                            </FormGroup>
                        </Col>
                    </Row>
                    {
                        form.ShowFrostProtection && 
                        <Row>
                            <Col sm="12">
                                <FormGroup check>
                                    <Label
                                        check
                                        for="isReceivesFreshWaterIrrigation"
                                    >
                                        Frost Protection
                                    </Label>
                                    <Input
                                        defaultChecked={form.FrostProtection}
                                        checked={form.FrostProtection}
                                        id="FrostProtection"
                                        name="FrostProtection"
                                        type="checkbox"
                                        value={form.FrostProtection}
                                        onChange={handleFormFieldChange}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    }
                </CardBody>
            </Collapse>
        </Card>
    )
}

export default EnterpriseDetailForm